import { ref, computed, onMounted, onBeforeUnmount } from 'vue';

const defaultBreakpoints = {
    mobileWide: 576,
    tablet: 768,
    desktop: 1024,
    desktopWide: 1280,
    desktopLarge: 1440,
};

export function useBreakpoint() {
    const currentBreakpoint = ref('desktop');
    const breakpoints = defaultBreakpoints;
    const isMobile = computed(() => ['mobile', 'mobileWide'].includes(currentBreakpoint.value));
    const isTablet = computed(() => currentBreakpoint.value === 'tablet');
    const isDesktop = computed(() => ['desktop', 'desktopWide', 'desktopLarge'].includes(currentBreakpoint.value));

    const getDeviceTypeByScreenWidth = (clientWidth: number) => {
        if (clientWidth < breakpoints.tablet) return 'mobile';
        if (clientWidth < breakpoints.desktop) return 'tablet';
        return 'desktop';
    };

    const updateBreakpoint = () => {
        if (typeof window === 'undefined') {
            currentBreakpoint.value = 'desktop';
            return;
        }

        const clientWidth = window.innerWidth;
        const { mobileWide, tablet, desktop, desktopWide, desktopLarge } = breakpoints;

        if (clientWidth < mobileWide) {
            currentBreakpoint.value = 'mobile';
        } else if (clientWidth < tablet) {
            currentBreakpoint.value = 'mobileWide';
        } else if (clientWidth < desktop) {
            currentBreakpoint.value = 'tablet';
        } else if (clientWidth < desktopWide) {
            currentBreakpoint.value = 'desktop';
        } else if (clientWidth < desktopLarge) {
            currentBreakpoint.value = 'desktopWide';
        } else {
            currentBreakpoint.value = 'desktopLarge';
        }
    };

    const handleResize = () => {
        updateBreakpoint();
    };

    onMounted(() => {
        updateBreakpoint();
        window.addEventListener('resize', handleResize);
    });

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize);
    });

    return {
        currentBreakpoint,
        breakpoints,
        isMobile,
        isTablet,
        isDesktop,
        getDeviceTypeByScreenWidth,
        updateBreakpoint,
        handleResize,
    };
}
